export default defineNuxtRouteMiddleware(async (_to, from) => {
	const nuxtApp = useNuxtApp()
	const localePath = useLocalePath()
	const adminStore = useAdminAuthStore()
	const isLoggedAdmin = useCookie('is_logged_admin')

	if (!isLoggedAdmin.value) {
		return navigateTo({ path: localePath('/panel/login'), query: { redirectAfter: from.fullPath } })
	}

	try {
		await adminStore.fetchUser()
	} catch (error) {
		logger.log(error)
		nuxtApp.runWithContext(() => adminStore.logout())
	}
})
